import { useColorMode } from '@vueuse/core'
import { computed } from 'vue'

export type ThemePreference = 'light' | 'dark' | 'auto'

const STORAGE_KEY = 'utm-theme'

export function useTheme() {
  const colorMode = useColorMode({
    attribute: 'class',
    storageKey: STORAGE_KEY,
    modes: {
      light: '',
      dark: 'dark',
    },
  })

  const preference = computed<ThemePreference>({
    get: () => {
      const value = colorMode.value
      if (value === 'dark' || value === 'light') return value
      return 'auto'
    },
    set: (value: ThemePreference) => {
      colorMode.value = value
    },
  })

  const isDark = computed(() => colorMode.value === 'dark')

  return { preference, isDark, colorMode }
}

export { STORAGE_KEY }
